import React, { useState, useEffect, useMemo } from "react";
import { GET_CANCELPLAN } from "../../utils/services";
import axios from "axios";
import CustomTable from "../../../Mycomponent/share/customTable";
import { DottLoader } from "../../../Mycomponent/share/loader";

const CancelPlan = () => {
  const [page, setPage] = React.useState(1);
  const [Data, setData] = useState({
    loading: true,
    data: [],
    error: false,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await axios.get(GET_CANCELPLAN());
        setData({
          loading: false,
          data: result.data,
          error: false,
        });
      } catch (error) {
        setData({
          loading: false,
          data: [],
          error: true,
        });
        console.error("Error fetching data:", error);
      }
    };

    fetchData(); // do NOT await here
  }, []);

  const tableHeader = useMemo(() => {
    return [
      {
        label: "EMAIL",
        key: "email",
        minWidth: 200,
        align: "left",
      },
      {
        label: "Reason",
        key: "reason",
        minWidth: 200,
        align: "left",
      },
    ];
  }, []);

  const rows = useMemo(() => {
    if (Data.data?.length > 0) {
      return Data.data;
    } else {
      return [];
    }
  }, [Data.data]);

  if (Data.loading) {
    return (
      <div>
        <h1 className="table_title heading-large font-bold mb-4">
          Cancel Plans
        </h1>
        <DottLoader />
      </div>
    );
  }

  return (
    <CustomTable
      showSearchBar={true}
      tableTitle="Cancel Plans"
      tableHeader={tableHeader}
      rows={rows}
      page={page}
      setPage={setPage}
    />
  );
};

export default CancelPlan;
